module.exports = __webpack_public_path__ + "static/pinkmuslinsetmain-9372101eba97ad6b270b656fcb7fce5a.jpeg";